<div class="zk-w-full">
	<div *ngIf="!disabled" class="zk-w-full cgi-search__wrapper">
		<label>
			<span class="freud-icon freud-icon-search freud-icon-md"></span>
			<input
				type="text"
				[placeholder]="'PROMPTUARY.ICD_PLACEHOLDER' | translate"
				[(ngModel)]="query"
				(keyup)="searchByQuery()"
			/>
		</label>

		<div
			class="options-list"
			*ngIf="showOptions && query && icdOptions?.length"
		>
			<ul>
				<li *ngFor="let option of icdOptions" (click)="select(option)">
					{{ option.description }}
				</li>
			</ul>
		</div>
	</div>
	<div>
		<div class="pill" *ngFor="let selected of value">
			{{ selected.description }}
			<span
				(click)="remove(selected)"
				class="freud-icon freud-icon-xxxs freud-icon-x"
				*ngIf="!disabled"
			></span>
		</div>
	</div>
</div>
